import React from "react";
import banner from "../../img/banner.png";

function Banner() {
  return (
    <main className="py-20 lg:h-screen 2xl:h-[80vh] my-auto px-4 lg:py-0 lg:px-0">
      <div className="h-full lg:w-screen max-w-screen-xl mx-auto flex items-center">
        <div className="flex-1 flex-grow">
          <div className="flex items-end mb-4">
            <p className="text-4xl animate-bounce">👋</p>
            <p className="text-center lg:text-left lg:text-xl text-gray-600 dark:text-gray-300 ml-4 tracking-widest font-primary">
              HELLO THERE, MY NAME IS{" "}
              <span className="text-black dark:text-white font-semibold">
                NEIL
              </span>
            </p>
          </div>
          <div>
            <h1 className="text-2xl text-center lg:text-left lg:text-6xl font-bold font-primary">
              I'm a Software Developer from Don Carlos, Bukidnon.
            </h1>
          </div>
          <div className="hidden lg:block w-10 bg-pink-600 h-1 my-6"></div>
          <div>
            <p className="mt-3 font-primary text-gray-700 dark:text-gray-300 text-justify lg:mt-0 lg:text-lg">
              I strive to gain new <b className="dark:text-white">knowledge</b>{" "}
              and improve my <b className="dark:text-white">skills</b> each day,
              with the goal of one day becoming a notable{" "}
              <b className="dark:text-white">Senior Developer</b> who can not
              only act independently but also knows how to{" "}
              <b className="dark:text-white">convey</b> thoughts and{" "}
              <b className="dark:text-white">communicate</b> with the team.
            </p>
          </div>
        </div>
        <div className="hidden relative h-full lg:flex justify-end items-end">
          <div className="absolute bottom-0 left-0 w-full h-14 bg-gradient-to-t from-white to-transparent z-40"></div>
          <img src={banner} alt="" className="h-6/7 object-contain z-20" />
          <div className="absolute top-0 left-0">
            <lottie-player
              src="https://assets6.lottiefiles.com/packages/lf20_3le10jj4.json"
              background="transparent"
              speed="1"
              loop
              autoplay
              style={{ width: 700, height: 700 }}
            ></lottie-player>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Banner;
